import {
  BaseAddressSchema,
  IntegrationsSchema,
} from "@redotech/redo-model/address-collection";
import * as z from "zod/v4";

export const createAddress = {
  name: "createAddress" as const,
  input: z.object({
    address: BaseAddressSchema,
    integrations: IntegrationsSchema.optional(),
  }),
  output: z.object({ addressId: z.string() }),
};
